import {
    CommandGroup,
    CommandItem,
} from '@/ui/design-system/components/ui/command';
import { useHistory, useLocation } from 'react-router';
import { mixpanelTrack } from 'utils/app';
import { shapeSpotlight } from 'utils/api/spotlights.api';
import { trackNavigation } from 'components/Link';

function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function SpotlightResults({ hits, onClose }) {
    const history = useHistory();
    const location = useLocation();

    if (!(hits && hits.length)) return null;

    return (
        <CommandGroup
            heading="Spotlights"
            className="float-left mb-3 w-full md:w-1/2 lg:w-1/3"
        >
            {hits
                .slice(0, 6)
                .map(shapeSpotlight)
                .map(({ id, title, images, link, externalLink }) => {
                    const trackAndNavigate = (openInNewTab) => {
                        if (externalLink) {
                            mixpanelTrack('navigation', {
                                context: 'SEARCH_RESULT',
                                from: location.pathname,
                                to: externalLink,
                            });
                            window.open(
                                externalLink,
                                '_blank',
                                'noopener,noreferrer',
                            );
                        } else if (link) {
                            trackNavigation(
                                location.pathname,
                                link,
                                'SEARCH_RESULT',
                            );
                            if (openInNewTab) {
                                window.open(link, '_blank');
                            } else {
                                history.push(link);
                            }
                        }
                        if (onClose) onClose();
                    };

                    return (
                        <CommandItem
                            key={id}
                            value={`spotlight-${title}-${id}`}
                            onSelect={() => trackAndNavigate(false)}
                            onClickCapture={(e) => {
                                if (isModifiedEvent(e)) {
                                    e.stopPropagation();
                                    trackAndNavigate(true);
                                }
                            }}
                        >
                            {images ? (
                                <img
                                    src={images}
                                    alt=""
                                    className="size-8 shrink-0 rounded-md object-cover"
                                />
                            ) : (
                                <div className="size-8 shrink-0 rounded-md bg-muted" />
                            )}
                            <span className="truncate">{title}</span>
                        </CommandItem>
                    );
                })}
        </CommandGroup>
    );
}

export default SpotlightResults;
